import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ModalType } from 'core/useCases/modal/types';
import { useModalStore } from 'stores/modal';
import { useDeleteContactMutation } from 'core/api/contacts';
import Delete from 'images/icons/Delete.svg?react';
import DeleteDisable from 'images/icons/DeleteDisable.svg?react';
import Contact from 'core/models/contact';
import ContactStatus from 'core/enums/contactStatus';

type DeleteContactButtonProps = {
    contact: Contact;
    postAction?: () => void;
};

const DeleteContactButton: FC<DeleteContactButtonProps> = ({ contact, postAction }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((s) => s.openModal);
    const deleteContactMutation = useDeleteContactMutation();

    const openConfirmationModal = () => {
        openModal({
            confirmAction: async () => {
                try {
                    // useDeleteContactMutation effectue le DELETE /api/contact/:id puis
                    // invalide le cache contacts (remplace DeleteContact + contactsFetcher).
                    await deleteContactMutation.mutateAsync(contact.id);

                    if (postAction) {
                        postAction();
                    }

                    toast.success(t('contact.remove-contact-success'));
                } catch (e) {
                    toast.error(t('common.error-occured'));
                }
            },
            defaultValues: contact,
            title: t('contact.ask-to-delete-contact'),
            type: ModalType.Confirmation,
        });
    };

    return contact.isDeletable ? (
        <button onClick={openConfirmationModal} title={t('common.delete')} type="button">
            <Delete />
        </button>
    ) : (
        <button
            title={t(
                `contact.delete-disabled-${
                    [ContactStatus.Incomplete, ContactStatus.New].includes(contact.status) ? 'open' : 'closed'
                }-status`,
            )}
            type="button"
            disabled
        >
            <DeleteDisable />
        </button>
    );
};

export default DeleteContactButton;
